<template>
    <div class="l-container-content bg-white">
        <div class="row">
            <div class="col-6">
                <h3>All Pickbox Games</h3>
            </div>
            <div class="col-6 text-right">
    
            </div>
        </div>
        <div class="row">
            <loader v-show="loading" />
            <vuetable ref="vuetable" :http-options="httpOptions" :api-url="url" :fields="columns" :sort-order="sortOrder" track-by="msisdn" :append-params="moreParams" :per-page="10" @vuetable:pagination-data="onPaginationData" @vuetable:loading="onLoading" @vuetable:loaded="onLoaded">
                <div slot="fullname" slot-scope="props">
                    {{props.rowData.first_name}} {{props.rowData.middle_name}}
    
                </div>

                <div slot="action" slot-scope="props">
                    <button class="button primary" id="editGame" @click="showModal(props.rowData)"><i class="fas fa-edit"></i></button>
                </div>

            </vuetable>
        </div>
        <div class="vuetable-pagination ui basic segment grid row">
            <div class="col text-left">
                <vuetable-pagination-info ref="paginationInfo"></vuetable-pagination-info>
            </div>
    
            <div class="col-6  text-right">
                <vuetable-pagination ref="pagination" @vuetable-pagination:change-page="onChangePage"></vuetable-pagination>
            </div>
    
        </div>
        <b-modal ref="editGameModal" hide-footer :title="'Edit Games - '+selectedPickBox.pickbox_game">
            <div v-show="errorcreateStatus">
                <small class="text-red">{{errorsMessage}}</small>
            </div>
            <div class="l-form row">
                <div class="col-6">
                    <label>Pickbox Game</label>
                    <input type="text" v-model="selectedPickBox.pickbox_game" placeholder="Enter Game">
                </div>
                <div class="col-6">
                    <label>Stake Amount</label>
                    <input type="number" v-model="selectedPickBox.stake_amount" placeholder="Enter Stake">
                </div>
    
                <div class="col-6">
                    <label>Maximum Win</label>
                    <input type="number" v-model="selectedPickBox.maximum_win" >
                </div>
                <div class="col-6">
                    <label>Free Bet</label>
                    <input type="number" v-model="selectedPickBox.free_bet_stake" >
                </div>
              
                <div class="col-6">
                    <label>Total Box</label>
                    <input type="number" v-model="selectedPickBox.total_box" >
                </div>
                <div class="col-6">
                    <label>RTP</label>
                    <input type="number" v-model="selectedPickBox.RTP" >
                </div>
    
            </div>
    
            <div class="mb-3">
                <b-button variant="outline-success" block @click="editGame()" id="editBTNGame">Edit Game</b-button>
            </div>
    
        </b-modal>
    </div>
</template>

<style>
td.vuetable-slot {
    overflow: visible !important;
}
</style>

<script>
import Vuetable from "vuetable-2/src/components/Vuetable";
import VuetablePagination from "vuetable-2/src/components/VuetablePagination";
import VuetablePaginationInfo from "vuetable-2/src/components/VuetablePaginationInfo";
import loader from "@/components/loader";
import store from "../store";
import $ from "jquery";

export default {
    components: {
        Vuetable,
        VuetablePagination,
        VuetablePaginationInfo,
        loader
    },
    name: "approvals",
    data() {
        return {
            loading: true,
            loadRecord: false,
            selected_data: {},
            url: "https://interactiveapi.chezagame.com/v1/pickbox/ussd/view/games",
            httpOptions: {
                headers: {
                    'X-App-Key': '09lib74145Qb3HO6eQTIfsbylRkyuZFT',
                    'X-Authorization-Key': 'ADMIN_APP',
                    'X-Requested-With': 'XMLHttpRequest',
                    'X-Token-Key': this.$cookies.get("accessToken")
                }
            },
            columns: [

                {
                    name: "pickbox_game",
                    title: 'Game',
                    sortField: "pickbox_game",
                    titleClass: "",
                    dataClass: ""
                },
                {
                    name: "total_box",
                    title: 'Total Box',
                    sortField: "total_box",
                    titleClass: "center aligned",
                    dataClass: "center aligned"
                },
                {
                    name: "stake_amount",
                    title: "Stake Amount",
                    sortField: "stake_amount",
                    titleClass: "",
                    dataClass: ""
                },
                {
                    name: "maximum_win",
                    title: "Maximum Win",
                    sortField: "maximum_win",
                    titleClass: "",
                    dataClass: ""
                },
                {
                    name: "RTP",
                    title: "RTP",
                    sortField: "RTP",
                },
                {
                    name: "free_bet_stake",
                    title: "Free Bet",
                    sortField: "free_bet_stake",
                },
                {
                    name: "created",
                    title: "Date",
                    sortField: "created",
                    callback: "created"
                },
                {
                    name: "action",
                    title: "Action",
                }
            ],
            range: "",
            search_match: "",
            loadOnStart: true,
            sortOrder: [{
                field: "created",
                direction: "desc"
            }],
            is_partial_resulting: false,

            moreParams: {
                start: "",
                filter: "",
                end: ""
            },
            selectedPickBox:{
                RTP: "",
                created: "",
                free_bet_stake: "",
                maximum_win: "",
                pickbox_game: "",
                pickbox_game_id: "",
                stake_amount: "",
                total_box: "",
            },
              errorcreateStatus: false,
            errorsMessage: ""
        };
    },
    mounted() {

        var vm = this;
        if (vm.$cookies.get("role_id") != 1 && vm.$cookies.get("role_id") != 2) {
            vm.$router.push({
                name: "dashboard"
            });
        }

        var start = moment().subtract(120, "days");
        var end = moment();

        function cb(start, end) {
            vm.dateFilter(start.format("YYYY-MM-DD"), end.format("YYYY-MM-DD"));
            $('input[name="dates"]').val(
                start.format("D MMMM, YYYY") + " - " + end.format("D MMMM, YYYY")
            );
        }

        $('input[name="dates"]').daterangepicker({
                startDate: start,
                endDate: end,
                ranges: {
                    Today: [moment(), moment()],
                    Yesterday: [
                        moment().subtract(1, "days"),
                        moment().subtract(1, "days")
                    ],
                    "Last 7 Days": [moment().subtract(6, "days"), moment()],
                    "Last 30 Days": [moment().subtract(29, "days"), moment()],
                    "This Month": [moment().startOf("month"), moment().endOf("month")],
                    "Last Month": [
                        moment()
                        .subtract(1, "month")
                        .startOf("month"),
                        moment()
                        .subtract(1, "month")
                        .endOf("month")
                    ]
                }
            },
            cb
        );

        cb(start, end);
    },
    watch: {
        data(newVal, oldVal) {
            this.$refs.vuetable.refresh();
        },
        range() {
            var start = this.range[0];
            var end = this.range[1];
            start = moment(start).format("YYYY-MM-DD");
            end = moment(end).format("YYYY-MM-DD");
            this.moreParams.start = start;
            this.moreParams.end = end;
            this.$refs.vuetable.refresh();
        }
    },
    methods: {
        showModal(val) {
            this.selectedPickBox = val
            this.$refs['editGameModal'].show()
        },
        hideModal() {
            this.$refs['editGameModal'].hide()
        },
        dateFilter: function(start, end) {
            var vm = this;

            vm.start = start;
            vm.end = end;

            vm.moreParams.start = start;
            vm.moreParams.end = end;

            this.$refs.vuetable.refresh();

            console.log("start date filter", start);
            console.log("end date filter ", end);
        },
        createdAt: function(value) {
            if (!value) {
                return "-";
            } else {
                return moment(value).format("h:mm a,DD MMM YYYY");
            }
        },
        searchRecord: function() {
            this.loadRecord = true;
            var str = this.search_match;
            var newString = str.indexOf("0") == 0 ? str.substring(1) : str;
            this.moreParams.filter = "254" + newString;
            this.$refs.vuetable.refresh();
        },
        dataManager(sortOrder, pagination) {
            if (this.data.length < 1) return;

            let local = this.data;

            // sortOrder can be empty, so we have to check for that as well
            if (sortOrder.length > 0) {
                console.log("orderBy:", sortOrder[0].sortField, sortOrder[0].direction);
                local = _.orderBy(
                    local,
                    sortOrder[0].sortField,
                    sortOrder[0].direction
                );
            }

            pagination = this.$refs.vuetable.makePagination(
                local.length,
                this.perPage
            );
            console.log("pagination:", pagination);
            let from = pagination.from - 1;
            let to = from + this.perPage;

            return {
                pagination: pagination,
                data: _.slice(local, from, to)
            };
        },
        onPaginationData(paginationData) {
            this.$refs.paginationInfo.setPaginationData(paginationData);
            this.$refs.pagination.setPaginationData(paginationData);
        },
        onChangePage(page) {
            this.$refs.vuetable.changePage(page);
        },
        onLoading() {
            this.loading = true;
            console.log("loading... show your spinner here");
        },
        onLoaded() {
            this.loading = false;
            console.log("loaded! .. hide your spinner here");
            $(".ui.dropdown").dropdown();
        },
        editGame() {
            let vm = this
            $.post({
                url: store.state.rootUrl + 'v1/pickbox/ussd/edit/games',
                type: "POST",
                headers: {
                    "X-App-Key": "09lib74145Qb3HO6eQTIfsbylRkyuZFT",
                    "X-Authorization-Key": "ADMIN_APP",
                    "X-Requested-With": "XMLHttpRequest",
                    "Content-Type": "application/json",
                    "X-Token-Key": vm.$cookies.get("accessToken")
                },
                data: JSON.stringify({
                    pickbox_game_id: vm.selectedPickBox.pickbox_game_id,
                    pickbox_game: vm.selectedPickBox.pickbox_game,
                    total_box: vm.selectedPickBox.total_box,
                    stake_amount: vm.selectedPickBox.stake_amount,
                    maximum_win: vm.selectedPickBox.maximum_win,
                    RTP: vm.selectedPickBox.RTP,
                    free_bet_stake: vm.selectedPickBox.free_bet_stake,
                }),
                success: function(response, status, jQxhr) {
                    // console.log(JSON.stringify(response.data.data));
                    $("#editBTNGame").text("Edit Game");
                    if (response.data.code == 200) {
                        vm.hideModal()
                    } else {

                        vm.errorcreateStatus = true;
                        vm.successcreateStatus = false;
                        vm.errorsMessage = response.data.message;
                    }

                },
                error: function(jQxhr, status, error) {
                    $("#editBTNGame").text("Edit Game");
                    var statustext = jQxhr.responseJSON.statusDescription;
                    vm.errorcreateStatus = true;
                    vm.successcreateStatus = false;
                    vm.errorsMessage = jQxhr.responseJSON.data.message;
                }
            });
        },
    }
};
</script>
